export default __webpack_public_path__ + "static/media/crown_3.c40fc92a.png";